import get from 'lodash.get';

export const selectConfig = (state) => get(state, 'countryConfig');

export const selectFeatureConfig = (state, featureName) => {
  const config = get(state, 'countryConfig') || [];

  const selectedFeatureConfig = config.find((feature) => featureName === feature.name);
  return [!!selectedFeatureConfig, selectedFeatureConfig?.data || {}];
};
